module.exports = __webpack_public_path__ + "img/qb1.138029f7.png";